// extracted by mini-css-extract-plugin
export default {"rootWrapper":"DemandList_rootWrapper__7Z+cO"};